var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.773,
    height: 16.442,
    viewBox: "0 0 28.773 16.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_110",
    d: "M-.4-.4A2.055,2.055,0,0,1,2.315-.569L2.508-.4,13.387,10.479,24.265-.4a2.055,2.055,0,0,1,2.713-.171l.193.171a2.055,2.055,0,0,1,.171,2.713l-.171.193L14.84,14.84a2.055,2.055,0,0,1-2.713.171l-.193-.171L-.4,2.508A2.055,2.055,0,0,1-.4-.4Z",
    transform: "translate(1 1)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.9a7ce3bfa83fe145ce64d9eed4d21183.svg";
export { ForwardRef as ReactComponent };